<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar title="Candidates" :icon="require('@/assets/admin-icon/menu/candidates_active.svg')">
        <div class="options">
          <widgetSearch placeholder="Search here..." icon="right" @keyup="searchCandidates">
          </widgetSearch>
          <div class="h-spacer"></div>
          <widgetDropdown v-model="show_display_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              Display
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in display_filter" :key="index"
                @click="changeDisplay(item)">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>
          <widgetDropdown v-model="show_sort_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              <img src="@/assets/admin-icon/filter.svg" />
              Filter
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in sort_filter" :key="index" @click="
                (sort_filter_data = item.value), (show_sort_filter = false)
                ">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>
          <widgetDropdown v-model="show_data_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              {{ filter_data == "mine" ? "My Candidates" : "All Candidates" }}
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in data_filter" :key="index"
                @click="(filter_data = item.value), (show_data_filter = false)">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>

          <div class="h-spacer"></div>
          <widgetButton :loading="false" @click="addSectionNew()" v-if="!$checkUserPermission('team-manager')"
            class="btn-secondary">
            Add Section +
          </widgetButton>
        </div>
      </WidgetToolbar>
    </div>

    <div v-if="columns.length > 0" class="page-body">
      <div class="wrapper-section" :style="{ minWidth: storyWindowWidth }">
        <div class="column story_body" :class="{ relaxed: view_type == 'relaxed' }" v-for="(item, index) in columns"
          :key="index">
          <div class="container">
            <div class="header">
              <div class="row-1">
                <div class="title" @click="editSection(item)">
                  {{ item.name | validate }}
                </div>
                <div class="options">
                  <button @click="addNewStory(item)" class="btn-add">+</button>
                </div>
              </div>
            </div>
            <div class="body" @dragover.self="columnDradOver($event, index)"
              @dragenter.self="columnDradEnter($event, index)" @dragleave.self="columnDradLeave($event, index)"
              @drop.self="columnDradDrop($event)">
              <div v-for="(candidate, i) in item.candidates" :key="i" class="card" draggable="true"
                @dragstart="cardDradStart($event, candidate, index, i)" @dragend="cardDragEnd"
                @dragover="cardDradOver($event, index)" @dragenter="cardDradEnter($event, index, i)"
                @dragleave="cardDradLeave($event, index)" @drop="cardDradDrop($event)">
                <div class="card-header">
                  <input type="checkbox" class="card-checkbox" />
                </div>
                <div class="card-body">
                  <widgetProfile :title="candidate.name" :subtitle="''" :file_name="candidate.photo"
                    :path="$fullUrl('images/profiles/')" :size="20" :text_size="8"></widgetProfile>
                  <div class="email" @click="viewStory(candidate)">
                    {{ candidate.email | validate }}
                  </div>
                  <div class="phone" @click="viewStory(candidate)">
                    {{ candidate.phone | validate }}
                  </div>
                  <div class="content" @click="viewStory(candidate)">
                    {{ candidate.description | validate }}
                  </div>
                </div>
                <div class="card-footer">
                  <div class="resume-widget">
                    <button v-if="candidate.cv_resume" @click="openResumeInNewTab(candidate.cv_resume)"
                      class="btn-download-resume">
                      <img class="icon" src="@/assets/icons/attach-file.svg" />
                      Resume
                    </button>
                    <div v-else class="no-resume">No Resume added</div>
                  </div>
                  <div class="card-date">
                    {{ moment(candidate.create_at).format("MMM DD, yyyy") }}
                  </div>
                </div>
              </div>
              <div @dragover="cardDradOver($event, index)" @dragleave="cardDradLeave($event, index)"
                @drop="cardDradDrop($event)" v-if="item.on_drag_active" class="drag-holder card">
                Drag here
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Not found -->
    <div v-else class="page-body">
      <div class="not-found">
        <widgetNotFoundWidget title="Looks like you haven’t added any section yet" :content="!$checkUserPermission('team-manager')
          ? 'Add a section to start adding candidates'
          : ''
          " :btntext="!$checkUserPermission('team-manager') ? 'Add Section +' : ''
    " @click="addSectionNew()">
          <img class="widget-img" src="@/assets/admin-icon/add-student-icon.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>

    <!-- Add Section modal -->
    <addCandidatesSectionModal v-if="show_section_form" :value="selected_section" :team_id="null" @saved="onSectionSaved"
      @close="show_section_form = false" @delete="deleteSection"></addCandidatesSectionModal>

    <!-- Add Story Modal -->
    <addCandidatesStoryModal v-if="show_form && selected_section" :value="story_item" :column_id="selected_section.id"
      @saved="onStorySaved" @close="onCloseStory()" @delete="deleteStory"></addCandidatesStoryModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
import addCandidatesSectionModal from "./components/addCandidatesSectionModal.vue";
import addCandidatesStoryModal from "./components/addCandidatesStoryModal.vue";
export default {
  components: {
    addCandidatesSectionModal,
    addCandidatesStoryModal,
  },
  data: () => ({
    view_type: "compact",
    show_form: false,
    columns: [],
    item_hold: null,
    active_column_index: null,
    active_card_index: null,
    inactive_column_index: null,
    inactive_card_index: null,
    show_section_form: false,
    loading_add_story: false,
    show_story_form: false,
    story_item: null,
    show_display_filter: false,
    display_filter: [
      {
        value: "relaxed",
        name: "Relaxed",
      },
      {
        value: "compact",
        name: "Compact",
      },
    ],
    show_sort_filter: false,
    sort_filter: [
      {
        value: "create_date",
        name: "Create Date",
      },
      {
        value: "name",
        name: "Name",
      },
    ],
    show_data_filter: false,
    data_filter: [
      {
        value: "mine",
        name: "My Candidates",
      },
      {
        value: "all",
        name: "All Candidates",
      },
    ],
    filter_data: "all",
    sort_filter_data: "",
    teams_filter_data: "",
    team_filter: [],
    candidate_search_result: [],
    selected_section: null,
    selected_candidate: null,
    storyWindowWidth: "0px",
  }),
  mounted() {
    let vm = this;
    vm.getCandidates(vm.filter_data);
  },
  methods: {
    openResumeInNewTab(cv_resume) {
      let vm = this;
      window.open(vm.$fullUrl("images/profiles/") + cv_resume, "_blank");
    },
    changeDisplay(item) {
      let vm = this;
      vm.view_type = item.value;
      vm.show_display_filter = false;
      if (vm.view_type == "relaxed") {
        vm.storyWindowWidth = vm.columns.length * 255 + "px";
      } else {
        vm.storyWindowWidth = vm.columns.length * 205 + "px";
      }
    },
    onCloseStory() {
      let vm = this;
      vm.show_form = false;
      vm.$router.push({
        name: "candidates",
      });
    },
    searchCandidates({ target }) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_SEARCH", {
          query: target.value,
          team_id: null,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => { });
    },
    filterBySort(val) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_FILTER_BY_SORT", {
          option: val,
          team_id: null,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
        })
        .catch((error) => { });
    },
    filterByTeam(val) {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("CANDIDATES_GET_ALL", { team_id: null })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
          vm.$store.dispatch("LOADER_CLOSE");
          if (vm.$route.params.id) {
            vm.columns.forEach((column) => {
              column.candidates.forEach((candidate) => {
                if (candidate.id == vm.$route.params.id) {
                  vm.viewStory(candidate);
                }
              });
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    getExistingCandidate(query) {
      let vm = this;
      if (vm.form.exist_candidate) {
        vm.$store
          .dispatch("SEARCH_EVERYTHING", {
            query: query,
            url: "/company/search-members",
            type: "site",
            team_id: null,
          })
          .then((response) => {
            vm.candidate_search_result = response.data;
          })
          .catch((error) => { });
      }
    },
    // ==============================================
    editStory(candidate) {
      let vm = this;
      vm.show_form = true;
    },
    viewStory(candidate) {
      let vm = this;
      vm.$router.push({
        name: "candidates",
        params: { id: candidate.id },
      });
      vm.story_item = candidate;
      vm.selected_section = { id: candidate.column_id };
      vm.editStory(candidate);
    },
    deleteStory(candidate) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_DELETE_STORY", {
          section_id: candidate.column_id,
          candidate_id: candidate.id,
          team_id: null,
        })
        .then((response) => {
          vm.show_form = false;
          vm.$router.push({
            name: "candidates",
          });
          vm.getCandidates(vm.filter_data);
        })
        .catch((error) => { });
    },
    getCandidates(type) {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("CANDIDATES_GET_ALL", {
          team_id: null,
          type: type,
        })
        .then((response) => {
          vm.columns = response.data.map((item) => {
            eventBus.$set(item, "on_drag_active", false);
            return item;
          });
          vm.$store.dispatch("LOADER_CLOSE");
          vm.changeDisplay({ value: vm.view_type });
          if (vm.$route.params.id) {
            vm.columns.forEach((column) => {
              column.candidates.forEach((candidate) => {
                if (candidate.id == vm.$route.params.id) {
                  vm.viewStory(candidate);
                }
              });
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    addNewStory(item) {
      let vm = this;
      vm.story_item = null;
      vm.selected_section = item;
      vm.show_form = true;
    },
    onStorySaved() {
      let vm = this;
      vm.show_form = false;
      vm.$router.push({
        name: "candidates",
      });
      vm.getCandidates(vm.filter_data);
    },
    // ===============================================
    deleteSection(id) {
      let vm = this;
      vm.$store
        .dispatch("CANDIDATES_DELETE_SECTION", {
          column_id: id,
          team_id: null,
        })
        .then((response) => {
          vm.show_section_form = false;
          vm.getCandidates(vm.filter_data);
        })
        .catch((error) => { });
    },
    editSection(item) {
      let vm = this;
      vm.selected_section = item;
      vm.show_section_form = true;
    },
    addSectionNew() {
      let vm = this;
      vm.selected_section = null;
      vm.show_section_form = true;
    },
    onSectionSaved() {
      let vm = this;
      vm.show_section_form = false;
      vm.getCandidates(vm.filter_data);
    },
    // =======================================
    cardDragEnd({ target }) {
      target.className = " card";
    },
    cardDradStart(e, item, column_index, card_index) {
      let vm = this;
      vm.item_hold = item;
      vm.inactive_column_index = column_index;
      vm.inactive_card_index = card_index;
      e.target.className += " hold";
      setTimeout(() => {
        e.target.className += " invisible";
      }, 0);
    },
    columnDradOver(e, index) {
      let vm = this;
      e.preventDefault();
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      vm.columns[index].on_drag_active = true;
    },
    columnDradEnter(e, index) {
      e.preventDefault();
      e.target.className += " hovered";
      let vm = this;
      vm.active_column_index = index;
    },
    columnDradLeave(e) {
      e.target.className = "body";
      let vm = this;
    },
    columnDradDrop(e) {
      let vm = this;
      e.target.className = "body";
      if (vm.active_column_index != null) {
        vm.columns[vm.active_column_index].candidates.push(vm.item_hold);
        vm.columns[vm.inactive_column_index].candidates.splice(
          vm.inactive_card_index,
          1
        );
        let card_index =
          vm.columns[vm.active_column_index].candidates.length - 1;
        vm.cardMove(card_index, vm.active_column_index);
      }
    },
    cardDradOver(e, index) {
      e.preventDefault();
      let vm = this;
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
      vm.columns[index].on_drag_active = true;
    },
    cardDradEnter(e, column_index, card_index) {
      e.preventDefault();
      let vm = this;
      vm.active_column_index = column_index;
      vm.active_card_index = card_index;
    },
    cardDradLeave(e) {
      let vm = this;
    },
    cardDradDrop(e) {
      let vm = this;
      if (vm.active_card_index != null) {
        vm.columns[vm.inactive_column_index].candidates.splice(
          vm.inactive_card_index,
          1
        );
        vm.columns[vm.active_column_index].candidates.splice(
          vm.active_card_index,
          0,
          vm.item_hold
        );
        vm.cardMove(vm.active_card_index, vm.active_column_index);
      }
      vm.columns.forEach((item) => {
        item.on_drag_active = false;
      });
    },
    cardMove(card_index, column_index) {
      let vm = this;
      let section_id = vm.columns[column_index].id;
      let story_id = vm.columns[column_index].candidates[card_index].id;
      vm.$store
        .dispatch("CANDIDATES_MOVE_STORY", {
          to_section_id: section_id,
          story_id: story_id,
          story_index: card_index,
        })
        .then((response) => {
          vm.show_story_form = false;
        })
        .catch((error) => { });
    },
  },
  watch: {
    sort_filter_data(val) {
      let vm = this;
      vm.filterBySort(val);
    },
    "form.candidate_name"(val) {
      let vm = this;
      vm.getExistingCandidate(val);
    },
    teams_filter_data(val) {
      let vm = this;
      vm.filterByTeam(val);
    },
    filter_data(val) {
      let vm = this;
      vm.getCandidates(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;
    }
  }

  .page-body {
    height: calc(100% - 43px);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    overflow-x: auto;

    .wrapper-section {
      height: 100%;
      display: flex;
      transition: 600ms ease-in-out;

      .column {
        width: 200px;
        margin-right: 5px;
        border-radius: 5px;
        height: 100%;
        display: flex;
        flex-direction: column;
        transition: 600ms ease-in-out;

        .container {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;

          .header {
            width: 100%;
            height: 45px;
            padding: 0px 5px;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            display: flex;
            background: #fff;

            .row-1 {
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 40px;
              width: 100%;
              border-bottom: 2px solid #ebebeb;

              .title {
                text-transform: capitalize;
                font-size: 12px;
                overflow: hidden;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
              }

              .options {
                .btn-add {
                  background: linear-gradient(180deg, #229fa5 0%, #229ea5 100%);
                  color: #fff;
                  border-radius: 5px;
                  padding-top: 1px;
                  width: 22px;
                  height: 22px;
                  margin-left: 14px;
                  font-size: 13px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                }
              }
            }
          }

          .body {
            width: 100%;
            max-height: calc(100% - 55px);
            min-height: 100px;
            overflow-y: auto;
            padding: 0px 5px;
            padding-bottom: 50px;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            display: flex;
            flex-direction: column;
            background: #fff;

            .card {
              width: 100%;
              background: #f5f5f5;
              position: relative;
              cursor: pointer;
              border-radius: 10px;
              margin-bottom: 5px;

              &:hover {
                .card-header {
                  .card-checkbox {
                    display: block;
                  }
                }
              }

              .card-header {
                display: flex;
                justify-content: flex-end;
                position: absolute;
                right: 2px;
                top: 2px;

                .card-checkbox:checked {
                  display: block;
                }

                .card-checkbox {
                  display: none;
                }
              }

              .card-body {
                display: flex;
                flex-direction: column;
                padding: 4px 7px;

                .phone {
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 500;
                  font-size: 11px;
                  color: #707070;
                  margin: 2px 0px;
                }

                .email {
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 500;
                  font-size: 11px;
                  color: #707070;
                  margin: 2px 0px;
                }

                .content {
                  margin: 2px 0px;
                  overflow: hidden;
                  text-decoration: none;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  font-family: "Nunito";
                  font-style: italic;
                  font-weight: 400;
                  font-size: 11px;
                  color: #3c3838;
                }
              }

              .card-footer {
                background: #f0f0f0;
                border-radius: 0px 0px 10px 10px;
                height: 35px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0px 5px;

                .resume-widget {
                  .btn-download-resume {
                    background: #f6f6f6;
                    border-radius: 5px;
                    display: flex;
                    align-items: center;
                    padding: 8px 8px;
                    font-size: 11px;
                    color: #0884af;

                    .icon {
                      margin-right: 5px;
                      width: 12px;
                    }
                  }

                  .no-resume {
                    font-family: "Nunito";
                    font-style: italic;
                    font-weight: 200;
                    font-size: 11px;
                    color: #707070;
                  }
                }

                .card-date {
                  font-family: "Nunito";
                  font-style: normal;
                  font-weight: 400;
                  font-size: 12px;
                  text-align: right;
                  color: #707070;
                }
              }

              &.hold {
                border: solid#04a5a5 1px;
                border-radius: 5px;
              }

              &.invisible {
                opacity: 0.5;
              }
            }

            .drag-holder {
              height: 80px;
              width: 100%;
              border: 1px dashed rgb(75, 75, 75);
              display: flex;
              align-items: center;
              justify-content: center;
            }

            &.hovered {
              background: #f4f4f4;
            }
          }
        }

        &.relaxed {
          width: 250px;

          .container {
            .body {
              .card {
                .due-date {
                  position: absolute;
                  bottom: 18px;
                  right: 15px;
                  font-size: 10px;
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .not-found {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      font-size: 20px;
      color: #000;
      background: #fff;
      border-radius: 10px;
    }

    .form-widget-modal {
      width: 400px;
      position: relative;

      .input-group {
        position: relative;

        .candidate-search-reasult {
          position: absolute;
          height: 200px;
          overflow-y: auto;
          z-index: 9999;
          background: #fff;
          box-shadow: 0px 0px 10px #a8a8a8;
          width: 100%;
          top: 62px;

          .candidate-item {
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            padding: 5px 10px;
            cursor: pointer;

            &:hover {
              background: rgb(241, 241, 241);
            }

            img {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .section-modal {
      width: 400px;

      .moder-header {
        display: flex;
        justify-content: space-between;

        .btn-section-delete {
          display: flex;
          align-items: center;

          img {
            width: 12px;
            margin-right: 3px;
            margin-top: -2px;
          }
        }
      }
    }

    .story-form-widget-modal {
      width: 400px;
      min-height: 200px;
      padding: 0px;

      .moder-header {
        display: flex;
        justify-content: space-between;
        position: relative;
        padding: 10px 10px;
        padding-bottom: 0px;
        margin-bottom: 0px;
        border-bottom: 1px solid #ddd;

        .options {
          display: flex;
          align-items: center;

          button {
            display: flex;
            align-items: center;
            margin-right: 10px;
            font-size: 15px;

            img {
              width: 15px;
              margin-right: 4px;
              margin-top: -4px;
            }
          }
        }

        .btn-close {
          font-size: 30px;
          color: #890000;
        }
      }

      .modal-body {
        padding: 0px 20px;
        padding-top: 20px;
        padding-bottom: 20px;

        h4,
        h5,
        h6,
        p {
          margin: 0px;
        }

        h4 {
          font-size: 14px;
          color: #000;
          margin-bottom: 21px;
          padding-bottom: 20px;
          border-bottom: 1px solid #ddd;
        }

        h5 {
          font-size: 17px;
          color: #707070;
          margin-bottom: 21px;
          padding-bottom: 20px;
          border-bottom: 1px solid #ddd;
        }

        h6 {
          font-size: 14px;
          color: #000;
          margin-bottom: 21px;
          padding-bottom: 20px;
          border-bottom: 1px solid #ddd;
        }

        p {
          font-size: 15px;

          color: #707070;
          margin-bottom: 4px;
        }

        .members {
          display: flex;
          flex-direction: column;
          margin-top: 10px;
          height: 150px;
          overflow-y: auto;

          .member {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            img {
              width: 23px;
              margin-right: 10px;
              border-radius: 50%;
            }
          }
        }
      }
    }
  }
}

.search-account-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-account-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: block;
  cursor: pointer;

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: block;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>
